<!--suppress XmlInvalidId -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <modal size="large"
           v-if="isShowModal"
           id="ModalFinancialMovement">

        <template v-slot:header>
            <h3 class="t-t-u title" :class="entity.movement_type" >{{modalTitle}}</h3>
        </template>

        <template v-slot:body>
            <div slot="body">
                <div class="form-row">
                    <div class="col-md-2 col-6 form-group">
                        <label for="finMovEditEmittedAt" class="required">Emissão</label>
                        <div class="input-group input-group-sm">
                            <input type="text"
                                   id="finMovEditEmittedAt"
                                   required="true"
                                   :class="{'is-invalid': errors.emitted_at}"
                                   v-model="entity.emitted_at"
                                   placeholder="DD/MM/AAAA"
                                   v-flatpickr
                                   v-mask="'##/##/####'"
                                   class="form-control form-control-sm t-c plch-center n-m-r-right">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <svg-icon icon="calendar-alt"/>
                                </div>
                            </div>
                        </div>
                        <field-messages :errors="errors.emitted_at"/>
                    </div>
                    <div class="col-md-2 col-6 form-group">
                        <label for="finMovEditScheduledTo"
                               :class="{required: entity.movement_type !== 'income'}">Vencimento</label>
                        <div class="input-group input-group-sm">
                            <input type="text"
                                   id="finMovEditScheduledTo"
                                   :required="entity.movement_type !== 'income'"
                                   :disabled="entity.movement_type === 'income'"
                                   :class="{'is-invalid': errors.scheduled_to}"
                                   v-model="entity.scheduled_to"
                                   placeholder="DD/MM/AAAA"
                                   v-flatpickr
                                   v-mask="'##/##/####'"
                                   class="form-control form-control-sm t-c plch-center n-m-r-right">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <svg-icon icon="calendar-alt"/>
                                </div>
                            </div>
                        </div>
                        <field-messages :errors="errors.scheduled_to"/>
                    </div>
                    <div class="col-md-2 col-6 form-group">
                        <label for="finMovEditValue" class="required">Valor</label>
                        <input type="text"
                               id="finMovEditValue"
                               required
                               :class="{'is-invalid': errors.value}"
                               v-model="entity.value"
                               v-money="money"
                               class="form-control form-control-sm t-r">
                        <field-messages :errors="errors.value"/>
                    </div>
                    <div class="col-6 col-md-2 form-group">
                        <label>Pago?</label>
                        <div class="checkbox-inline" style="padding: 5px">
                            <label><input type="checkbox"
                                          v-model="entity.paid"
                                          @change="entity.paid_at = null"
                                          class="checkbox green m"/><span class="t-t-u c-theme f-w-700"> {{entity.paid | bool2Human}}</span></label>
                        </div>
                    </div>
                    <div class="col-md-2 col-6 form-group">
                        <label for="finMovEditPaidAt" :class="{required: entity.paid}">Pagamento</label>
                        <div class="input-group input-group-sm">
                            <input type="text"
                                   id="finMovEditPaidAt"
                                   :required="entity.paid"
                                   :class="{'is-invalid': errors.paid_at}"
                                   :disabled="!entity.paid"
                                   v-model="entity.paid_at"
                                   placeholder="DD/MM/AAAA"
                                   v-flatpickr
                                   v-mask="'##/##/####'"
                                   class="form-control form-control-sm t-c plch-center n-m-r-right">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <svg-icon icon="calendar-alt"/>
                                </div>
                            </div>
                        </div>
                        <field-messages :errors="errors.paid"/>
                        <field-messages :errors="errors.paid_at"/>
                    </div>
                    <div class="col-md-2 col-6 form-group">
                        <label for="finMovEditCount">Recorrente?</label>
                        <input type="number"
                               id="finMovEditCount"
                               placeholder="Número de recorrências"
                               min="1"
                               v-model.number="entity.quantity"
                               class="form-control form-control-sm t-r">
                    </div>
                </div>
                <div class="form-row" v-if="entity.movement_type === 'people'">
                    <div class="col-md-2 col-6 form-group">
                        <label for="finMovEditDiscount">Descontos</label>
                        <input type="text"
                               id="finMovEditDiscount"
                               :class="{'is-invalid': errors.discount}"
                               v-model="entity.discount"
                               v-money="money"
                               class="form-control form-control-sm t-r">
                        <field-messages :errors="errors.discount"/>
                    </div>
                    <div class="col-md-2 col-6 form-group">
                        <label for="finMovEditAdditions">Acréscimos</label>
                        <input type="text"
                               id="finMovEditAdditions"
                               :class="{'is-invalid': errors.additions}"
                               v-model="entity.additions"
                               v-money="money"
                               class="form-control form-control-sm t-r">
                        <field-messages :errors="errors.additions"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-2 col-4 form-group">
                        <label for="finMovEditPayType" class="required">Formato</label>
                        <select id="finMovEditPayType"
                                required
                                v-model="entity.payment_type"
                                :class="{'is-invalid': errors.payment_type}"
                                class="form-control form-control-sm">
                            <option v-for="pt in payment_types" :value="pt.name">{{pt.label}}</option>
                        </select>
                        <field-messages :errors="errors.payment_type"/>
                    </div>
                    <div class="col-md-3 col-8 form-group">
                        <label for="finMovEditIdentifier">Identificador</label>
                        <input type="text"
                               id="finMovEditIdentifier"
                               placeholder="Facilite a localização"
                               :class="{'is-invalid': errors.identifier}"
                               v-model="entity.identifier"
                               class="form-control form-control-sm">
                        <field-messages :errors="errors.identifier"/>
                    </div>
                    <div class="col-md-7 col-12 form-group" v-if="entity.movement_type !== 'people'">
                        <label for="finMovEditCustomer">Cliente</label>
                        <Autocomplete id="finMovEditCustomer"
                                      v-model="entity.customer_name"
                                      placeholder="Informe o nome cliente"
                                      url="/v1/financial_movements/search/customers?criteria="
                                      :input-class="['form-control form-control-sm', {'is-invalid': errors.customer_id}]"
                                      :on-select-item="returnValue"
                                      :item-value-presentation="itemValuePresentation"
                                      :item-presentation="itemPresentation"/>
                        <field-messages :errors="errors.customer_id"/>
                    </div>
                    <div v-else class="col-md-7 col-6 form-group">
                        <label for="finMovEditBroker" class="required">Colaborador</label>
                        <select id="finMovEditBroker"
                                required
                                :disabled="lockUserInput"
                                v-model="entity.broker_id"
                                :class="{'is-invalid': errors.broker_id}"
                                class="form-control form-control-sm">
                            <option v-for="u in users" :disabled="u.removed" :key="u.id" :value="u.id">{{u.name}} {{u.last_name}}</option>
                        </select>
                        <field-messages :errors="errors.broker_id"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-4 form-group" v-if="entity.movement_type !== 'people'">
                        <label for="finMovEditInvoices">Notas</label>
                        <SelectX
                                input-id="finMovEditInvoices"
                                placeholder="Notas relacionadas"
                                v-model="invoices"
                                allow-include-new="false"
                                @onRemoveItem="item => onRemoveItem(item, 'invoice')"
                                data-source="/v1/financial_movements/search/invoices"
                        />
                    </div>
                    <div class="form-group" :class="{'col-md-8': entity.movement_type !== 'people', 'col-md-12': entity.movement_type === 'people'}">
                        <label for="finMovEditProposals">Negócios</label>
                        <SelectX
                                input-id="finMovEditProposals"
                                placeholder="Negócios relacionados"
                                v-model="proposals"
                                allow-include-new="false"
                                @onRemoveItem="item => onRemoveItem(item, 'proposal')"
                                data-source="/v1/financial_movements/search/proposals"
                        />
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 form-group">
                        <label for="finMovEditDescription">Descrição</label>
                        <textarea id="finMovEditDescription"
                                  class="form-control form-control-sm"
                                  v-model="entity.description"></textarea>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button type="button"
                    @click="saveFinMov"
                    class="btn btn-sm" :class="`btn-${entity.movement_type.replace(/_/, '-')}`">
                <svg-icon icon="save"/>
                Salvar
            </button>
            <button type="button"
                    @click="reset"
                    class="btn btn-sm btn-secondary">
                <svg-icon icon="sync"/>
                Limpar
            </button>
            <button type="button"
                    @click="() => {isShowModal = false; $emit('closeModal')}"
                    class="btn btn-sm btn-dark">
                <svg-icon icon="times"/>
                Fechar
            </button>
        </template>
    </modal>
</template>

<script>
    import {EventBus, SHOW_FIN_MOV} from "../../utils/EventBus";
    import Autocomplete from '@/components/particles/Autocomplete'
    import SelectX from '@/components/particles/SelectX'
    import {createNamespacedHelpers} from 'vuex'
    import dayjs from 'dayjs'
    const {mapActions} = createNamespacedHelpers('financial_movements');

    const movementTypes = {
        income: 'Recebível',
        fixed_expenses: 'Despesa Fixa',
        taxes: 'Imposto',
        variable_expenses: 'Despesa Variável',
        people: 'Colaborador'
    };

    const mold = {
        id: null,
        value: null,
        discount: null,
        additions: null,
        movement_type: 'income',
        paid: false,
        paid_at: null,
        scheduled_to: null,
        identifier: null,
        payment_type: 'bank_transfer',
        emitted_at: null,
        broker_id: null,
        customer_name: '',
        financial_movement_invoices_attributes: [],
        financial_movement_proposals_attributes: []
    };

    export default {
        name: "ModalFinancialMovement",
        components: {Autocomplete, SelectX},
        data() {
            return {
                errors: {},
                entity: {},
                isShowModal: false,
                payment_types: [],
                users: [],
                lockUserInput: false,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2
                },
                invoices: [],
                proposals: [],
                removed_invoices: [],
                removed_proposals: [],
                callbackModal: null
            }
        },
        methods: {
            ...mapActions(['loadPaymentTypes', 'save', 'load']),
            returnValue(obj) {
                this.entity.customer_id = obj.id;
            },
            onRemoveItem(item, type){
                if (item.id && type === 'proposal') {
                    this.removed_proposals.push({
                        proposal_id: item.proposal_id,
                        id: item.id,
                        financial_movement_id: item.financial_movement_id,
                        _destroy: true
                    })
                }

                if (item.id && type === 'invoice') {
                    this.removed_invoices.push({
                        invoice_id: item.invoice_id,
                        id: item.id,
                        financial_movement_id: item.financial_movement_id,
                        _destroy: true
                    })
                }
            },
            itemPresentation(obj, val) {
                const regex = new RegExp(val, 'gi');
                const name = this.$appUtils.highlightText(obj.name, regex);
                const city_name = this.$appUtils.highlightText(obj.city.name, regex);
                const state_acronym = this.$appUtils.highlightText(obj.city.state.acronym, regex);

                let document = 'SEM DOCUMENTO';
                let doc_len = 0;

                if (obj.document) {
                    document = this.$appUtils.highlightText(this.$appUtils.formatDocument(obj.document), regex);
                    doc_len = obj.document.length;
                }

                return ['<div class="ellipsis">', name, '</div>', '<div style="font-size: .8em" class="ellipsis">', (doc_len === 14 ? 'CNPJ' : 'CPF'),': ', document, ' | CIDADE: ', city_name, '/', state_acronym, '</div>'].join('');
            },
            itemValuePresentation: obj => obj.name,
            saveFinMov() {

              const entity = Object.assign({}, this.entity);

              entity.financial_movement_proposals_attributes = [];
              this.proposals.forEach(i => {
                let p;

                if (i.proposal_id) {
                  p = {
                    id: i.id,
                    proposal_id: i.proposal_id,
                    financial_movement_id: i.financial_movement_id
                  }
                } else {
                  p = {
                    proposal_id: parseInt(i.id)
                  }

                  if (entity.id) p.financial_movement_id = entity.id;
                }

                entity.financial_movement_proposals_attributes.push(p)
              });

              this.removed_proposals.forEach(i => {
                entity.financial_movement_proposals_attributes.push({
                  id: i.id,
                  proposal_id: i.proposal_id,
                  financial_movement_id: i.financial_movement_id,
                  _destroy: true
                })
              });

              entity.financial_movement_invoices_attributes = [];
              this.invoices.forEach(i => {
                let inv;

                if (i.invoice_id) {
                  inv = {
                    id: i.id,
                    invoice_id: i.invoice_id,
                    financial_movement_id: i.financial_movement_id
                  }
                } else {
                  inv = {
                    invoice_id: parseInt(i.id)
                  }

                  if (entity.id) inv.financial_movement_id = entity.id;
                }

                entity.financial_movement_invoices_attributes.push(inv)
              });

              this.removed_invoices.forEach(i => {
                entity.financial_movement_invoices_attributes.push({
                  id: i.id,
                  invoice_id: i.invoice_id,
                  financial_movement_id: i.financial_movement_id,
                  _destroy: true
                })
              });

              this.save(entity)
                  .then(data => {
                    this.entity.id = data.id;
                    this.$snotify.success('Lançamento salvo com sucesso!', this.$appStorage.getUser().name);

                    this.removed_proposals = [];
                    this.removed_invoices = [];

                    this.invoices = data.financial_movement_invoices_attributes || [];
                    this.proposals = data.financial_movement_proposals_attributes || [];

                    this.errors = {};

                    if (this.callbackModal) this.callbackModal(data);
                  })
                  .catch(({response}) => {
                    this.$appUtils.vibrate(200);

                    if (response.status === 422) {
                      Object.keys(response.data).forEach(k => {
                        this.$set(this.errors, k, response.data[k]);
                      });
                      this.$snotify.warning('Verifique os dados informados', 'Validação');
                    } else if (response.status === 403) {
                      this.$snotify.error('Você não possui permissão para executar essa ação', 'Permissão')
                    } else {
                      this.$snotify.error('Ops... Aconteceu algum problema inesperado. Tente novamente e caso o problema persista, contate o suporte.', 'Falha')
                    }
                  });
            },
            reset() {
                this.entity = Object.assign({}, mold, {movement_type: this.entity.movement_type});

                const date = dayjs().format('DD/MM/YYYY');

                this.entity.emitted_at = date;
                this.scheduled_to = this.entity.movement_type !== 'income' ? date : null

                this.removed_proposals = [];
                this.removed_invoices = [];
                this.invoices = [];
                this.proposals = [];

                this.errors = {};
            },
            loadUsers() {
                this.$appHttp.get('/v1/financial_movements/load_users')
                    .then(({data}) => this.users = data)
                    .catch(console.error)
            }
        },
        mounted() {
            this.loadPaymentTypes()
                .then(result => this.payment_types = result)
                .catch(console.error);

            EventBus.$on(SHOW_FIN_MOV, options => {
                const e = options.entity || {};
                this.callbackModal = options.callback;

                this.errors = {};
                this.invoices = [];
                this.proposals = [];
                this.removed_invoices = [];
                this.removed_proposals = [];

                if ('people' === e.movement_type) this.loadUsers()

                if (e.id) {
                    this.load(e.id)
                        .then(data => {
                            if (data.movement_type === 'people' && this.users.length === 0) this.loadUsers();
                            this.entity = Object.assign({}, data, {
                                value: this.$appUtils.formatMoney(data.value),
                                discount: this.$appUtils.formatMoney(data.discount),
                                additions: this.$appUtils.formatMoney(data.additions),
                                created_at: this.$appUtils.formatDate(data.created_at),
                                emitted_at: this.$appUtils.formatDate(data.emitted_at),
                                scheduled_to: this.$appUtils.formatDate(data.scheduled_to),
                                paid_at: this.$appUtils.formatDate(data.paid_at),
                            });

                            this.invoices = data.financial_movement_invoices_attributes || [];
                            this.proposals = data.financial_movement_proposals_attributes || [];

                            if (options.mode === 'clone') {
                                this.entity.id = null;

                                this.invoices.forEach(i => i.id = null);
                                this.proposals.forEach(p => p.id = null);

                                this.$snotify.success('Lançamento clonado com sucesso!', this.$appStorage.getUser().name);
                            }

                            this.isShowModal = true;
                        })
                        .catch(({response}) => {
                            if (response.status === 403) {
                                this.$snotify.error(this.$t('common.403'), this.$appStorage.getUser().name);
                            } else {
                                this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar carregar o lançamento.'}), this.$appStorage.getUser().name);
                            }
                        });
                } else if ('commission' === options.mode) {
                    this.entity = Object.assign({}, mold, e);
                    this.lockUserInput = true;
                    if (this.$appUtils.isArray(options.proposals)) {
                        options.proposals.forEach(p => {
                            this.proposals.push({
                                id: p.id,
                                label: p.number
                            })
                        });
                        this.isShowModal = true;
                    }
                } else {
                    this.entity = Object.assign({}, mold, e);
                    this.isShowModal = true;
                }
            })
        },
        computed: {
            modalTitle() {
                const prefix = this.entity.id ? 'Alterar' : 'Incluir';
                return `${prefix} ${movementTypes[this.entity.movement_type]}`
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/variables";
    .title {
        transition: color .2s ease;

        &.income {
            color: $income_main_color;
        }
        &.variable_expenses {
            color: $variable_expenses_main_color;
        }
        &.fixed_expenses {
            color: $fixed_expenses_main_color;
        }
        &.taxes {
            color: $taxes_main_color;
        }
        &.people {
            color: $people_main_color;
        }
    }
</style>
